import React from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { Breadcrumbs, Link, Typography, Stack } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';

// Helper to format URL segments into readable text
const formatSegment = (segment) =>
  segment.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

// Reusable BreadcrumbHeader component
const BreadcrumbHeader = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(Boolean);

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
      <Breadcrumbs aria-label="breadcrumb">
        {/* Home breadcrumb */}
        <Link
          component={RouterLink}
          to="/"
          underline="hover"
          color="inherit"
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Homepage
        </Link>

        {/* Dynamic segments */}
        {pathnames.map((segment, index) => {
          const to = '/' + pathnames.slice(0, index + 1).join('/');
          const isLast = index === pathnames.length - 1;

          return isLast ? (
            <Typography color="text.primary" key={to}>
              {formatSegment(segment)}
            </Typography>
          ) : (
            <Link
              component={RouterLink}
              to={to}
              underline="hover"
              color="inherit"
              key={to}
            >
              {formatSegment(segment)}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Stack>
  );
};

export default BreadcrumbHeader;
